import { FaWhatsapp } from "react-icons/fa";
import { BriefcaseBusiness } from "lucide-react";
import { useRecruitmentModal } from "../RecruitmentModal/RecruitmentModal";

function FloatingEnquiry() {
  const { openRecruitmentModal } = useRecruitmentModal();
  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-[9999]">
      <button
        type="button"
        onClick={() => openRecruitmentModal()}
        className="absolute -top-40 right-0 flex h-36 w-10 flex-col items-center justify-center gap-2 rounded-l-2xl border border-slate-200 bg-white text-xs font-semibold tracking-[0.16em] text-[#163A63] shadow-xl transition-all hover:bg-slate-50"
        aria-label="We're hiring: send your resume"
      >
        <BriefcaseBusiness
          size={16}
          className="shrink-0 text-red-500"
          aria-hidden="true"
        />
        <span className="[writing-mode:vertical-rl]">WE&apos;RE HIRING</span>
      </button>
      <a
        href="https://wa.me/971526013353"
        target="_blank"
        rel="noopener noreferrer"
        className="relative block cursor-pointer"
      >
        {/* Enquiry Tab */}
        <div
          className="
            w-10
            h-36
            bg-white
            rounded-l-2xl
            border border-slate-200
            shadow-xl
            flex
            items-center
            justify-center
            hover:bg-slate-50
            transition-all
          "
        >
          <span
            className="
              [writing-mode:vertical-rl]
              tracking-[0.35em]
              text-[#163A63]
              text-xs
              font-semibold
            "
          >
            ENQUIRY
          </span>
        </div>

        {/* WhatsApp Icon */}
        <div
          className="
            absolute
            -bottom-4
            left-1/2
            -translate-x-1/2
            w-10
            h-10
            rounded-full
            bg-[#25D366]
            text-white
            flex
            items-center
            justify-center
            shadow-xl
            hover:scale-110
            transition-all
          "
        >
          <FaWhatsapp size={20} />
        </div>
      </a>
    </div>
  );
}

export default FloatingEnquiry;
